(function () {
  if (customElements.get('researcher-verification-gate')) return;

  class ResearcherVerificationGate extends HTMLElement {
    connectedCallback() {
      if (this.dataset.crvInit === 'true') return;
      this.dataset.crvInit = 'true';

      this.storageKey = this.dataset.storageKey;
      this.exitUrl = this.dataset.exitUrl;
      this.submitButton = this.querySelector('[data-crv-submit]');
      this.checkboxes = Array.from(this.querySelectorAll('[data-crv-check]'));
      this.exitLink = this.querySelector('[data-crv-exit]');
      this.section = this.closest('[id^="shopify-section-"]');

      if (this.isVerified()) {
        this.hideSection();
        return;
      }

      this.updateSubmitState();

      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', () => this.updateSubmitState());
      });

      if (this.submitButton) {
        this.submitButton.addEventListener('click', () => this.handleSubmit());
      }

      if (this.exitLink) {
        this.exitLink.addEventListener('click', (event) => {
          event.preventDefault();
          window.location.href = this.exitUrl;
        });
      }
    }

    isVerified() {
      try {
        return sessionStorage.getItem(this.storageKey) === 'true';
      } catch (error) {
        return false;
      }
    }

    hideSection() {
      if (this.section) {
        this.section.classList.add('crv-hidden');
        this.section.setAttribute('hidden', '');
      }
      document.documentElement.classList.remove('crv-pending');
      document.documentElement.classList.add('crv-verified');
    }

    setVerified() {
      try {
        sessionStorage.setItem(this.storageKey, 'true');
      } catch (error) {
        /* ignore */
      }
      document.documentElement.classList.remove('crv-pending');
      document.documentElement.classList.add('crv-verified');
    }

    updateSubmitState() {
      const allChecked = this.checkboxes.every((checkbox) => checkbox.checked);
      if (!this.submitButton) return;

      this.submitButton.disabled = !allChecked;
      this.submitButton.classList.toggle('is-ready', allChecked);
    }

    handleSubmit() {
      if (!this.checkboxes.every((checkbox) => checkbox.checked)) return;
      this.setVerified();
      this.dismiss();
    }

    dismiss() {
      this.classList.remove('is-active');
      this.hideSection();
    }
  }

  customElements.define('researcher-verification-gate', ResearcherVerificationGate);
})();
